
<template>
  <div class="lin-tab">
    <el-tabs v-model="activeTab"
             type="border-card"
             closable
             @tab-remove="removeTab"
             @tab-click="clickBtn">
      <el-tab-pane :key="item.title"
                   v-for="item in tabList"
                   :label="item.title"
                   :name="item.path">
        {{ item.content }}
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
 
<script>
import store from "../store/index";
export default {
  name: "",
  data () {
    return {
      // 当前活跃的tabs
      activeTab: "",
    };
  },
  components: {},
  computed: {
    tabList () {
      return store.getters["getTabs"];
    },
  },
  watch: {
    $route: function () {
      this.setActiveTab();
      this.addTab();
    },
  },
  created () { },
  mounted () {
    this.setActiveTab();
    this.addTab();
    this.startPolling();
  },
  methods: {
    startPolling () {
      let timer = setInterval(() => {
        const newValue = localStorage.getItem("userInfo");
        if (newValue) {
          this.beforeRefresh();
          clearTimeout(timer);
        }
      }, 500); // 每秒检查一次
    },
    // 设置活跃的tab
    setActiveTab () {
      if (this.$route.path == "/loginform") {
        return;
      }
      this.activeTab = this.$route.path;
    },
    // 添加tab
    addTab () {
      const { path, meta } = this.$route;
      const tab = {
        path,
        title: meta.title,

      };
      if (path == "/repDistribution") {
        return
      }
      if (meta.activeMenu) {
        this.activeTab = meta.activeMenu;
        return
      }
      if (
        path == "/salaryCalculationDetail" ||
        path == "/salaryCalculationGenerated" ||
        path == "/addTimesheet" ||
        path == "/addDayTimesheet"
      ) {
        this.activeTab = "/salaryCalculationList";
        return;
      }
      if (path == "/salaryBehalfDetail") {
        this.activeTab = "/salaryBehalfList";
        return;
      }
      if (path == "/insuranceIntroduction" || path == "/insuranceForm") {
        this.activeTab = "/insuranceList";
        return;
      }
      if (path == "/cardList") {
        this.activeTab = "/cardListIndex";
        return;
      }
      if (path == "/BuyCenter") {
        this.activeTab = "/home";
        return;
      }
      if (path == "/certifiForm") {
        this.activeTab = "/certifiSelection";
        return;
      }
      if (path == "/personalForm") {
        this.activeTab = "/certifiSelection";
        return;
      }
      if (path == "/insuranceOrderDetail") {
        this.activeTab = "/insuranceOrders";
        return;
      }
      if (path == "/wxrepDistributionDetail") {
        this.activeTab = "/wxrepDistribution";
        return;
      }
      if (path == "/WeChatBehalfDetail") {
        this.activeTab = "/WeChatBehalf";
        return;
      }
      if (path == "/businessDescriptionPage") {
        this.activeTab = "/businessAccount";
        return;
      }
      if (path == "/insuranceDescriptionPage") {
        this.activeTab = "/insuranceList";
        return;
      }
      if (path == "/businessDescriptionPage") {
        this.activeTab = "/businessAccount";
        return;
      }
      if (path == "/reportFormsDetail") {
        this.activeTab = "/reportForms";
        return;
      }
      if (path == "/reportFormsDetailManage") {
        this.activeTab = "/reportFormsManage";
        return;
      }
      if (path == "/rosterDetail") {
        this.activeTab = "/roster";
        return;
      }
      if (path == "/rosterDetailManage") {
        this.activeTab = "/rosterManage";
        return;
      }
      if (path == "/cardDescriptionPage") {
        this.activeTab = "/cardListIndex";
        return;
      }
      store.commit("addTab", tab);
    },
    // 点击tab
    clickBtn (tab) {
      const { name } = tab;
      this.$router.push({ path: name });
    },
    // 删除tab
    removeTab (target) {
      // 当前激活的tab
      if (target == "/home") return;
      let active = this.activeTab;
      const tabs = this.tabList;
      // 只有一个标签页的时候不允许删除
      if (tabs.length === 1) return;
      if (active === target) {
        tabs.forEach((tab, index) => {
          // 如果删除的就是当前活跃的tab,就把活跃的tab变成上一个
          if (tab.path == target) {
            active = tabs[index - 1].path;
          }
        });
      }
      this.$router.push({ path: active });
      // 重新设置当前激活的选项卡和 选项卡列表
      this.activeTab = active;
      store.state.tabList = tabs.filter((tab) => tab.path !== target);
      sessionStorage.setItem(
        "tabsView" + JSON.parse(localStorage.getItem("userInfo")).cname,
        JSON.stringify(this.tabList)
      );
    },
    // 解决刷新数据丢失问题
    beforeRefresh () {
      console.log(this.tabList);
      window.addEventListener("beforeunload", () => {
        sessionStorage.setItem(
          "tabsView" + JSON.parse(localStorage.getItem("userInfo")).cname,
          JSON.stringify(this.tabList)
        );
      });
      console.log(2);
      let tabSession = sessionStorage.getItem(
        "tabsView" + JSON.parse(localStorage.getItem("userInfo")).cname
      );
      if (tabSession) {
        let oldTabs = JSON.parse(tabSession);
        if (oldTabs.length > 0) {
          store.state.tabList = oldTabs;
        }
      }
    },
  },
};
</script>

<style lang="less" >
.lin-tab {
  width: 100%;

  height: 31px;
  background-color: #f5f7fa;

  .el-tabs__item {
    height: 31px;
    line-height: 28px;
  }
}
.lin-tab .el-tabs--border-card > .el-tabs__header {
  background-color: #f5f7fa;
}
.el-tabs--border-card > .el-tabs__header {
  border-bottom: 0;
}
.el-tabs--border-card {
  border-bottom: 0;
}
.el-submenu__title:hover,
.el-menu-item:focus,
.el-menu-item:hover {
  background-color: rgba(218, 217, 217, 0.699) !important;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  border-radius: 16px;
  border: solid 1px #dddddd;
  margin-top: 0;
  margin-right: 10px;
  padding: 0 15px;
}
.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #e6a23c;
  border: solid 1px #e6a23c;
  color: white;
}
</style>
